document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-grida-pdp]');
  if (!root) return;
/* ---------- Variant data ---------- */
const VARIANTS = {
  medium: {
    label: 'Medium',
    dim_metric: '80 \u00d7 50 cm',
    dim_imperial: '31.5" \u00d7 19.7"',
    weight: '5 kg',
    price: 159.99,
    compare: 269.99,
    status: 'in_stock',
    ship_eta: 'Ships in 1\u20132 business days.'
  },
  large: {
    label: 'Large',
    dim_metric: '100 \u00d7 60 cm',
    dim_imperial: '39.4" \u00d7 23.6"',
    weight: '7 kg',
    price: 209.99,
    compare: 349.99,
    status: 'preorder',
    ship_eta: "Reserve now \u2014 ships early August. You won't be charged until it ships."
  }
};

const chips = root.querySelectorAll('.size-chip');
const priceNow = root.querySelector('#priceNow');
const priceCompare = root.querySelector('#priceCompare');
const priceSave = root.querySelector('#priceSave');
const addBtn = root.querySelector('#addToBag');
const addLabel = root.querySelector('#addLabel');
const addPrice = root.querySelector('#addPrice');
const mbPrice = root.querySelector('#mbPrice');
const mbSize = root.querySelector('#mbSize');
const mbBtn = root.querySelector('#addToBagMobile');
const mbLabel = root.querySelector('#mbLabel');
const availEl = root.querySelector('#avail');
const availLabel = root.querySelector('#availLabel');
const availSub = root.querySelector('#availSub');
const ctaNote = root.querySelector('#ctaNote');

let currentSize = 'medium';
const fmt = n => '$' + n.toFixed(2);

function setSize(size) {
  const v = VARIANTS[size];
  if (!v) return;
  currentSize = size;
  chips.forEach(c => c.classList.toggle('active', c.dataset.size === size));

  priceNow.textContent = fmt(v.price);
  priceCompare.textContent = fmt(v.compare);
  priceSave.textContent = 'Save $' + Math.round(v.compare - v.price);

  if (v.status === 'in_stock') {
    availEl.classList.remove('preorder');
    availLabel.textContent = 'In stock';
    availSub.textContent = v.ship_eta;
    addLabel.textContent = 'Add to Bag';
    mbLabel.textContent = 'Add to Bag';
    ctaNote.classList.remove('show');
  } else {
    availEl.classList.add('preorder');
    availLabel.textContent = 'Pre-order';
    availSub.textContent = v.ship_eta;
    addLabel.textContent = 'Pre-order';
    mbLabel.textContent = 'Pre-order';
    ctaNote.classList.add('show');
  }

  mbSize.textContent = v.label + ' \u00b7 ' + v.dim_metric;
  updateAddBtn();
}
chips.forEach(c => c.addEventListener('click', () => setSize(c.dataset.size)));

/* ---------- Quantity ---------- */
const qty = root.querySelector('#qty');
root.querySelector('#qtyMinus').addEventListener('click', () => { qty.value = Math.max(1, parseInt(qty.value || '1') - 1); updateAddBtn(); });
root.querySelector('#qtyPlus').addEventListener('click', () => { qty.value = Math.min(20, parseInt(qty.value || '1') + 1); updateAddBtn(); });
qty.addEventListener('input', () => {
  let n = parseInt(qty.value || '1');
  if (isNaN(n) || n < 1) n = 1; if (n > 20) n = 20;
  qty.value = n; updateAddBtn();
});
function updateAddBtn() {
  const v = VARIANTS[currentSize];
  const n = parseInt(qty.value || '1');
  addPrice.textContent = fmt(v.price * n);
  mbPrice.textContent = fmt(v.price * n);
}

/* ---------- Pre-order "Why?" ---------- */
const whyBtn = root.querySelector('#availWhy');
const whyDetail = root.querySelector('#availWhyDetail');
if (whyBtn) {
  whyBtn.addEventListener('click', (e) => {
    e.preventDefault();
    whyDetail.classList.toggle('open');
    whyBtn.textContent = whyDetail.classList.contains('open') ? 'Hide' : 'Why pre-order?';
  });
}

/* ---------- Add to bag ---------- */
let cart = 0;
const cartCount = root.querySelector('#cartCount');
const toast = root.querySelector('#toast');
const toastName = root.querySelector('#toastName');
const toastSub = root.querySelector('#toastSub');
let toastT;
function addToBag() {
  const v = VARIANTS[currentSize];
  const n = parseInt(qty.value || '1');
  cart += n; cartCount.textContent = cart;
  toastName.textContent = v.status === 'in_stock' ? 'Added to bag' : 'Pre-order reserved';
  toastSub.textContent = 'Grida WindowPane \u00b7 ' + v.label + ' \u00b7 ' + fmt(v.price * n);
  toast.classList.add('show');
  clearTimeout(toastT);
  toastT = setTimeout(() => toast.classList.remove('show'), 2800);
}
addBtn.addEventListener('click', addToBag);
mbBtn.addEventListener('click', addToBag);

root.querySelectorAll('.quick-add').forEach(b => {
  b.addEventListener('click', e => {
    e.preventDefault(); e.stopPropagation();
    cart++; cartCount.textContent = cart;
    toastName.textContent = 'Added to bag';
    toastSub.textContent = b.dataset.name + ' \u00b7 $' + b.dataset.price;
    toast.classList.add('show');
    clearTimeout(toastT);
    toastT = setTimeout(() => toast.classList.remove('show'), 2400);
  });
});

/* ---------- Mobile sticky ---------- */
const mobileBar = root.querySelector('#mobileBar');
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (window.innerWidth > 900) { mobileBar.classList.remove('show'); return; }
    mobileBar.classList.toggle('show', !e.isIntersecting);
  });
}, { threshold: 0.1 });
io.observe(addBtn);


window.GridaPdpSetSize = setSize;
setSize('medium');

});
